import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * P922A module permission hook
 * pgCode = "pw922af1" (SYS_Program)
 */
export function useP922APermissions() {
  return useModulePermission(Modules.P922A);
}
